import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// ROUTING
import { useNavigate } from "react-router-dom";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateOrganizationRefreshTable } from "../../../redux/organizations/organizationSlice";
// COMPONENTS
import ButtonRefreshTable from "../../components/buttons/ButtonRefreshTable";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function OrganizationsHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissions } = useSelector((state: RootState) => state.user);
  const userLogged = useSelector((state: any) => state.home.userLogged);

  const isMasterAdmin =
    userLogged &&
    userLogged.role &&
    userLogged.role.name === process.env.REACT_APP_ROLE_MASTER_NAME;

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickReloadPage = () => {
    dispatch(updateOrganizationRefreshTable(true));
    setTimeout(() => {
      dispatch(updateOrganizationRefreshTable(false));
    }, 1000);
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="generalStyles__pageHeader">
      {validatePermission("orgs-view", permissions) && (
        <div className="generalStyles__mlFix mt-1">
          <ButtonRefreshTable
            onClick={onClickReloadPage}
            label={t("organizationManagement.refreshTable")}
          />
        </div>
      )}
      {isMasterAdmin && (
        <div className="generalStyles__mlFix mt-1" style={{ marginLeft: 12 }}>
          <Button type="primary" onClick={() => navigate("/setup-wizard")}>
            Setup New Organization
          </Button>
        </div>
      )}
    </div>
  );
}

export default OrganizationsHeader;
